import React, { Fragment, useEffect, useState } from "react";
import downloadIcon from "../../assets/img/Icon feather-upload-cloud.png";
import eyeIcon from "../../assets/img/eye.png";
import {
  getDsiputeDwonloadFiles,
  getDsiputePreviewFiles,
} from "../../adapters/apis/lookups/lookups";
import useFileHandler from "../../hooks/useFileHandler";
import AttachmentName from "../../helpers/AttachmentName";
import DownloadFile from "../../helpers/DownloadFile";

function InputElement(props) {
  const { handleDownload, handlePreviewClick } = useFileHandler();
  const checkType = props.inputType;

  let errorBorder = "";

  if (props.pText) {
    errorBorder = " invalid";
  }

  const [stateType, setStateType] = useState("password");
  const handleClick = () =>
    setStateType(stateType === "text" ? "password" : "text");

  const validateManySpace = (string) => {
    return /[ ]{2,}/.test(string);
  };
  const validateRegax = (e) => {
    if (!validateManySpace(e.target.value)) {
      props.onChange(
        props.parentCompenent,
        props.compenent,
        props.name,
        e.target.value,
        props.index,
        props.buildingIndex,
        props.floorIndex,
      );
    }
  };

  const customNumberRules = (e) => {
    let is_valid = true;
    if (
      parseInt(e.target.value) < 1 ||
      e.target.value.toString().includes("-") ||
      e.target.value.toString() === " "
    ) {
      return;
    }
    if (e.target.value.toString() === "" && props.value.length !== 1) {
      return "";
    }

    // check if it's found any عدد words you shouldn't accept '.'
    if (
      props.labelText.includes("عدد") &&
      e.target.value.toString().includes(".")
    ) {
      return;
    } else {
      if (e.target.value.toString().includes("."))
        if (e.target.value.toString().split(".")[1].length > 2) {
          e.target.value = parseFloat(e.target.value).toFixed(2);
        }
    }

    if (is_valid)
      props.onChange(
        props.parentCompenent,
        props.compenent,
        props.name,
        e.target.value,
        props.index,
        props.buildingIndex,
      );
  };

  if (checkType === "number") {
    return (
      <Fragment>
        <div className={props.mb4}>
          <label htmlFor={props.labelHtmlFor} className={props.labelClassName}>
            {props.labelText}
            {props.tooltipText && (
              <span className="tooltip">
                <i className="fa-regular fa-circle-question fa-fw"></i>
                <span className="tooltiptext">{props.tooltipText}</span>
              </span>
            )}
          </label>
          <input
            type={props.inputType}
            className={props.inputClassName + errorBorder}
            id={props.inputID}
            value={props.value}
            disabled={props.disabled}
            min={props.min ? props.min : 1}
            max={props.max}
            pattern={props.pattern}
            maxLength={props.maxLength}
            placeholder={props.placeholder} // Add this line
            onChange={(e) => customNumberRules(e)}
          />
          {props.pText && <p className={props.pClassName}>{props.pText}</p>}
        </div>
      </Fragment>
    );
  } else if (checkType === "password") {
    return (
      <Fragment>
        <div className={props.mb4}>
          <label htmlFor={props.labelHtmlFor} className={props.labelClassName}>
            {props.labelText}
            {props.tooltipText && (
              <span className="tooltip">
                <i className="fa-regular fa-circle-question fa-fw"></i>
                <span className="tooltiptext">{props.tooltipText}</span>
              </span>
            )}
          </label>
          <input
            autoComplete="new-password"
            type={stateType}
            className={props.inputClassName + errorBorder}
            id={props.inputID}
            value={props.value}
            disabled={props.disabled}
            min={props.min ? props.min : 1}
            max={props.max}
            maxLength={props.maxLength}
            placeholder={props.placeholder ?? `ادخل ${props.labelText}..`} // Add this line
            pattern={
              props.allowedPattern instanceof RegExp
                ? props.allowedPattern.source
                : props.allowedPattern
            }
            onChange={(e) => {
              const val = e.target.value;
              const isValid =
                !props.allowedPattern ||
                val === "" ||
                props.allowedPattern.test(val);
              if (isValid) {
                if (props.customChange) {
                  validateRegax(e);
                }
                props.onChange(
                  props.parentCompenent,
                  props.compenent,
                  props.name,
                  val,
                  props.index,
                  props.buildingIndex,
                  props.floorIndex,
                );
              }
            }}
          />
          <div className="password__show" onClick={handleClick}>
            {stateType === "text" ? (
              <i className="fa-solid fa-eye-slash"></i>
            ) : (
              <i className="fa-solid fa-eye"></i>
            )}
          </div>

          {props.pText &&
            (Array.isArray(props.pText) ? (
              props.pText.map((item, index) => (
                <p key={index} className={props.pClassName}>
                  {item}
                </p>
              ))
            ) : (
              <p className={props.pClassName}>{props.pText}</p>
            ))}
        </div>
      </Fragment>
    );
  } else if (checkType !== "file") {
    return (
      <Fragment>
        <div className={`${props.mb4} position-relative`}>
          <label htmlFor={props.labelHtmlFor} className={props.labelClassName}>
            {props.labelText}
            {props.tooltipText && (
              <span className="tooltip">
                <i className="fa-regular fa-circle-question fa-fw"></i>
                <span className="tooltiptext">{props.tooltipText}</span>
              </span>
            )}
          </label>
          {props.profile ? (
            <div className={props.profileDiv}>
              <input
                type={props.inputType}
                className={props.inputClassName + errorBorder}
                id={props.inputID}
                value={props.value}
                disabled={props.disabled}
                min={props.min}
                max={props.max}
                maxLength={props.maxLength}
                style={props.styleInputProfile}
                placeholder={props.placeholder ?? `ادخل ${props.labelText}..`} // Add this line
                onChange={(e) => {
                  if (props.allowedPattern) {
                    if (
                      e.target.value === "" ||
                      props.allowedPattern.test(e.target.value)
                    ) {
                      if (props.customChange) {
                        validateRegax(e);
                        if (props.onChange) props.onChange(e);
                      } else {
                        return validateRegax(e);
                      }
                    }
                  } else {
                    if (props.customChange) {
                      validateRegax(e);
                      if (props.onChange) props.onChange(e);
                    } else {
                      return validateRegax(e);
                    }
                  }
                }}
                pattern={
                  props.allowedPattern instanceof RegExp
                    ? props.allowedPattern.source
                    : props.allowedPattern
                }
                // customChange={props.customChange}
              />

              {props.isButton && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={props.buttonOnClick}
                  style={props.styleButtonProfile}
                  disabled={props.buttonDisabled}
                >
                  {props.buttonText}
                </button>
              )}
            </div>
          ) : (
            <input
              type={props.inputType}
              className={props.inputClassName + errorBorder}
              id={props.inputID}
              value={props.value}
              disabled={props.disabled}
              min={props.min}
              max={props.max}
              maxLength={props.maxLength}
              placeholder={props.placeholder ?? `ادخل ${props.labelText}..`} // Add this line
              onChange={(e) => {
                if (props.allowedPattern) {
                  if (
                    e.target.value === "" ||
                    props.allowedPattern.test(e.target.value)
                  ) {
                    if (props.customChange) {
                      validateRegax(e);
                      if (props.onChange) props.onChange(e);
                    } else {
                      return validateRegax(e);
                    }
                  }
                } else {
                  if (props.customChange) {
                    validateRegax(e);
                    if (props.onChange) props.onChange(e);
                  } else {
                    return validateRegax(e);
                  }
                }
              }}
              pattern={
                props.allowedPattern instanceof RegExp
                  ? props.allowedPattern.source
                  : props.allowedPattern
              }
              // customChange={props.customChange}
            />
          )}
          {props.isIcon && (
            <div
              className="position-absolute d-flex gap-2"
              style={{ top: "46px", left: "10px" }}
            >
              <button
                style={{ border: "none" }}
                onClick={() => {
                  if (props.serverSide) {
                    props.previewFunction();
                  } else {
                    handlePreviewClick(
                      props.idDownload,
                      props.filedDownload,
                      getDsiputePreviewFiles,
                    );
                  }
                }}
              >
                <img src={eyeIcon} alt="eyeIcon" className="img-fluid" />
              </button>
              {/* Vertical Divider */}
              <div
                style={{
                  width: "1px",
                  height: "24px",
                  backgroundColor: "#ccc",
                }}
              ></div>
              <button
                onClick={() => {
                  if (props.serverSide) {
                    props.downloadFunction();
                  } else {
                    handleDownload(
                      props.idDownload,
                      props.filedDownload,
                      getDsiputeDwonloadFiles,
                    );
                  }
                }}
                style={{ border: "none", background: "transparent" }}
              >
                <img
                  src={downloadIcon}
                  alt="downloadIcon"
                  className="img-fluid"
                />
              </button>
            </div>
          )}
          {props.pText && <p className={props.pClassName}>{props.pText}</p>}
          {props.pVerificationText && (
            <p className={props.pVerificationClass}>
              {props.pVerificationMessage}
            </p>
          )}
        </div>
      </Fragment>
    );
  } else {
    return (
      <Fragment>
        <div className={props.mb4}>
          <label htmlFor={props.labelHtmlFor} className={props.labelClassName}>
            {props.labelText}

            {props.tooltipText && (
              <span className="tooltip">
                <i className="fa-regular fa-circle-question fa-fw"></i>
                <span className="tooltiptext">{props.tooltipText}</span>
              </span>
            )}
          </label>
          <div className={props.inputIcon + " input-icon-custom"}>
            <input
              ref={props.fileInputRef}
              type={props.inputType}
              className={
                props.inputClassName + errorBorder + " fileCustomDispute"
              }
              id={props.inputID}
              disabled={props.disabled}
              file-name={props.fileName}
              // fileName={props.fileName}
              file-data={props.fileData ? props.fileData : "No"}
              placeholder={props.placeholder} // Add this line
              onChange={(e) =>
                props.onChange(
                  props.parentCompenent,
                  props.compenent,
                  props.name,
                  e.target.files[0],
                  props.index,
                  props.buildingIndex,
                  props.floorIndex,
                  props.fileInputRef,
                )
              }
            />

            {props.labelHint && (
              <p className={props.hintClass}>{props.labelHint}</p>
            )}
            {props.pText && <p className={props.pClassName}>{props.pText}</p>}

            <i
              className={props.icon}
              onClick={() => {
                if (props.fileInputRef?.current) {
                  props.fileInputRef.current.click();
                }
              }}
              style={{ cursor: "pointer" }}
            ></i>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default InputElement;
